import Alpine from "alpinejs";
import Headroom from "headroom.js";

Alpine.data("nav", () => ({
  openClassName: 'open',
  isOpen: false,
  init() {
    this.setNavHeightGlobally();

    const headroom = new Headroom(this.$root);
    headroom.init();

    // keep the bar (and its X button) in place while the menu is open, otherwise scrolling
    // slides the bar away / makes it compact while the menu panel stays where it is
    this.$watch("isOpen", (open: boolean) => {
      if (open) {
        headroom.pin();
        headroom.freeze();
      } else {
        headroom.unfreeze();
      }
    });
  },
  destroy() {},
  setNavHeightGlobally() {
    const navHeight = (this.$refs.navBar as HTMLElement)
      ?.offsetHeight;

    document
      .querySelector("body")
      .style.setProperty("--js-nav-bar-height", navHeight + "px");
  },
}));
